<template>
  <TimeEntriesBaseSelectFilter
    label="Time zone"
    placeholder="Time zone"
    query-property="time_zone"
    :allow-clear="false"
    :options="timeZonesOptions"
    :default-option="active_time_zone"
    :multiple="false"
  />
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'TimeEntriesTimeZoneFilter',
  computed: {
    ...mapState(['active_time_zone']),
    ...mapGetters(['timeZones']),
    timeZonesOptions() {
      return this.timeZones.map(t => ({
        id: t.for,
        text: `${t.description} (${t.abbr}: ${t.display_name})`,
      }))
    }
  },
};
</script>
